import React, { useState }  from "react";

// components
//import HomeNavbar from "../../components/Navbars/HomeNavbar";
import UserAttendanceApproval from "../../../components/Cards/UserAttendanceApproval";

export default function AttendanceApproval() {
  
  return (
    <>
      
      <main>
        <div className="relative block py-24 lg:pt-0 ">
          <UserAttendanceApproval></UserAttendanceApproval>
        </div>
      </main>
      
    </>
  );
}
